<script setup>
import { computed } from 'vue'
import Modal from '@/components/ui/Modal.vue'
import Button from '@/components/ui/Button.vue'

const props = defineProps(['show', 'title', 'body', 'options', 'modalClass'])
const emit = defineEmits(['clicked', 'update:show'])

const showModal = computed({
    get: () => props.show,
    set: (val) => emit('update:show', val),
})
</script>

<template>
    <Modal
        v-model="showModal"
        :title="title"
        :modal-class="modalClass ?? 'modal-w-sm'"
        no-close
    >
        <p>{{ body }}</p>

        <template #modal-footer>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 90%;">
                <Button
                    v-for="option in options"
                    :key="option.value"
                    :variant="option.variant ?? 'primary'"
                    :class="option.class ?? ''"
                    @click="emit('clicked', option.value)"
                >
                    {{ option.label }}
                </Button>
            </div>
        </template>
    </Modal>
</template>

<style lang="scss">
@import "../../assets/stylesheets/colors";

.modal-w-sm .btn-danger {
    background-color: $dark-red;
    border-color: $dark-red;
}

.btn {
    font-weight: bold !important;
}

.btn-white {
    border-color: #e5e5e5 !important;
    background-color: #fff !important;
    color: #000 !important;
}
</style>
